module.exports = __webpack_public_path__ + "static/media/dodge.bfc8a794.png";